import { createContext } from 'react';
import { UsePermissions } from '../types/UsePermissions';

export const PermissionContext = createContext<UsePermissions>({
    hasPermission: () => false,
    hasPermissions: () => false,
    permissions: [],
    initialised: false
});
